angular.module('impactx.address').controller('AddressDirectiveCtrl', AddressDirectiveCtrl);

AddressDirectiveCtrl.$inject = ['$scope', 'dataGen'];

/**
 * This is a slimmed down version of the address detail dialog controller.
 * Use this as controller for the "app-address" directive, so the detail dialog controller does not need to deal with
 * pre-set data.
 */
function AddressDirectiveCtrl($scope, dataGen) {
    var adrId, ctrl = this;

    $scope.expandAddress = false;
    $scope.expandContact = false;
    
    var addressSizeValue = 'BASIC_DIALOG';
    if($scope.addressSize === 'full') {
        addressSizeValue = 'FULL_DIALOG';
    }
    else if($scope.addressSize === 'standard') {
        addressSizeValue = 'STANDARD_DIALOG';
    }

    
    if($scope.data && $scope.data.adr && $scope.data.adr.addressId) {
        adrId = $scope.data.adr.addressId;
        $scope.restricted = !impactX.isDefined($scope, 'data.adr.hasRightToEdit') && impactX.isDefined($scope, 'data.adr.hasRightToEditRestricted');
    }
    else {
        adrId = 0;
        $scope.restricted = false;
    }

    this.handleNuts = function() {
        var address,
            scope = {};

        address = $scope.data.adr;

        if (address.zip && address.country.selected) {
            return dataGen.postAsForm(scope, {
                zip: address.zip.value,
                ctyId: address.country.selected.id
            }, "/address/ziptonuts").then(function () {
                var bestNuts, availableNuts, currentNuts;

                currentNuts = address.nutsCode;
                bestNuts = scope.data.bestCode;
                availableNuts = scope.data.options;

                if ((currentNuts && availableNuts.indexOf(currentNuts) !== -1) || !address.nuts) {
                    address.nutsCode.value = bestNuts;
                }
                $scope.availableNuts = availableNuts;
            });
        }
    };

    this.checkVisible = function(field){
        if(field) {
            return field.visible || false;
        }
        return false;
    };

    this.checkRequired = function (field) {
        if (field) {
            if (field.showMust) {
                return true;
            }
            return field.requiredIfContactAddress && $scope.data.adr.isContactAddress.value
        }
        return false;
    }

    if(!($scope.data && $scope.data.adr && $scope.data.adr.addressId)) {
        dataGen.getData({}, {id: adrId, size: addressSizeValue}, "/address/view").then(function(data) {
            if (!$scope.data)
            {
                $scope.data = {};
            }
            $scope.data.adr = data.data.adr;
            $scope.trns = data.trns;
            ctrl.handleNuts();
        });
    }
    else {
        ctrl.handleNuts();
    }
}